<template>
  <div class="sd-manual-list">
    <header class="sd-manual-list__heading">
      <h1 v-text="title"></h1>
      <p v-html="description"></p>
    </header>
    <div class="sd-manual-list__content">
      <div class="sd-product-manual__interactive-product"
           :class="model.slug"
           v-for="model in models"
           :key="model.id">
        <sd-watch
          class="sd-manual-list__product-model"
          :data="model" :display-only="true">
        </sd-watch>
        <div class="sd-manual-list__product-model--details">
          <header class="watch-model">
            <h2 class="model-name" v-text="model.name"></h2>
            <h5 class="model-number" v-text="model.slug.toUpperCase()"></h5>
          </header>
          <router-link
            class="sd-button sd-button_lt_sm"
            :to="{name: 'productManual', params: {title: model.name, modelName: model.slug}}"
            tag="button">
            <span>Test Drive</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sdWatch from '@/components/models/Watch';
import manualService from '@/services/manualService';

export default {
  name: 'ProductManualList',
  components: {
    sdWatch,
  },
  props: [],
  data() {
    return {
      title: 'Test drive',
      description: 'Take our watches for a spin with the Swiss Delta <b>Test Drive</b>.',
      models: manualService.models,
    };
  },
};
</script>

<style lang="scss" scoped>
  @import './../styles/typography';
  @import './../styles/variables';

  ////////////
  // PRODUCT MANUAL LIST
  ////////////

  .sd-manual-list {
    display: block;
  }
  .sd-manual-list__heading {
    margin-bottom: 48px;
  }
  .sd-manual-list__content {
    flex: 0 0 auto;
    width: auto;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(60mm, 1fr));
    grid-auto-rows: minmax(600px, 1fr);
    grid-gap: 36px;
    .sd-product-manual__interactive-product {
      display: flex;
      flex-flow: column nowrap;
      height: auto;
      padding: 24px;
      margin-top: 0;
      zoom: unset;
      background: #FFDEAD;
      box-shadow: 0 0 0 12px #FFDEAD;
      @media (max-width: 599px) and (orientation: portrait) {
        max-height: none;
      }
    }
    .sd-button {
      flex: 0 0 auto;
      margin-left: auto;
    }
  }
  .sd-manual-list__product-model {
    width: 100%;
    padding: 12px 0 0;
    margin-bottom: 12px;
    height: auto;
    flex: 1 1 100%;
  }
  .sd-manual-list__product-model--details {
    width: 100%;
    align-self: flex-start;
    text-align: center;
    padding-bottom: 18px;
    .model-name {
      font-weight: 300;
      font-size: 36px;
      line-height: 0.9;
      letter-spacing: -0.03em;
      transform: translateX(-0.09em);
      margin-bottom: 12px;
    }
    .sd-button {
      margin-top: 36px;
    }
  }
</style>
